function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "49.8995881%",
  y1: "100.003488%",
  x2: "49.8995881%",
  y2: "0.00311374074%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F37C27",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ED3774",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M24.8165779,207.36323 L24.8165779,88.229422 L127.997263,28.6488313 L127.997263,147.788114 L231.183422,88.229422 L231.183422,207.36323 L127.997263,266.943821 L24.8165779,207.36323 L24.8165779,207.36323 Z M115.591711,7.14441522 L12.4110263,66.7195312 L0,73.8967943 L0,88.2348966 L0,207.368705 L0,221.717756 L12.4110263,228.88407 L115.597186,288.464661 L127.997263,295.630975 L140.413764,288.453711 L243.594448,228.873121 L256,221.706807 L256,207.357755 L256,88.229422 L256,73.8913197 L243.594448,66.7140566 L140.413764,7.14441522 L127.997263,0 L115.591711,7.14441522 L115.591711,7.14441522 Z",
  fill: "url(#linearGradient-1)"
}));

const SvgHeap = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "256px",
  height: "296px",
  viewBox: "0 0 256 296",
  preserveAspectRatio: "xMidYMid",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/heap.fffbeb9b.svg";
export { ForwardRef as ReactComponent };